import { IframeResponse } from './models';
const iframeresponse: IframeResponse = {
    psbodds: [],
    psbCSOdds: [],
    orOddsInsured: [],
    stage: '',
    league: ''
}
export default iframeresponse